import _ from "lodash";
import {
  FIRST_NAME,
  NAME_MAPPING,
  DEFAULT_NAME_ORDER_PREFERENCE,
} from "Constants/stringConstants";
import {
  ENABLE_USER_MIDDLE_NAME,
  PARENT_NAME_ORDER,
  PARENT_PRINT_NAME_ORDER,
} from "Constants/permissionConstants";
import { store } from "store/createStore";
import { getCleanNameOption } from "./GetCleanNameOption";
import ACLStore from "lib/aclStore";
import { getSettingValue } from "modules/PermissionModule";

const _getDefaultFamilyNameOrderPreference = () => {
  const state = store.getState();
  const userType = _.get(state, "login.userInfo.user_type", "");
  if (_.isEqual(userType, "parent")) {
    return DEFAULT_NAME_ORDER_PREFERENCE;
  }
  const parentNameOrder =
    getSettingValue({
      name: PARENT_NAME_ORDER,
      readFromUserAndOrgLevel: true,
    }) || DEFAULT_NAME_ORDER_PREFERENCE;

  return parentNameOrder;
};

const getDefaultFamilyNameOrderPreference = _.memoize(
  _getDefaultFamilyNameOrderPreference,
  params => JSON.stringify(params)
);

const _getDefaultFamilyPrintNameOrderPreference = () => {
  const parentNameOrder =
    getSettingValue({
      name: PARENT_PRINT_NAME_ORDER,
      readFromUserAndOrgLevel: true,
    }) || DEFAULT_NAME_ORDER_PREFERENCE;

  return parentNameOrder;
};

const getDefaultFamilyPrintNameOrderPreference = _.memoize(
  _getDefaultFamilyPrintNameOrderPreference,
  params => JSON.stringify(params)
);

const getDefaultNameOrderPreferenceForFamily = shouldGeneratePrintOrder => {
  let defaultStudentNameOrderPreference = [];
  if (shouldGeneratePrintOrder) {
    defaultStudentNameOrderPreference = getDefaultFamilyPrintNameOrderPreference();
  } else {
    defaultStudentNameOrderPreference = getDefaultFamilyNameOrderPreference();
  }
  return defaultStudentNameOrderPreference;
};

// for now simple function, can add orderBy validation in future if required
export const getFormattedFamilyMemberName = ({
  familyMember,
  shouldGeneratePrintOrder = false,
}) => {
  const { firstName = "", lastName = "" } = familyMember || {};

  if (ACLStore.can(ENABLE_USER_MIDDLE_NAME)) {
    let fullName = "";
    const defaultParentNameOrderPreference = getDefaultNameOrderPreferenceForFamily(
      shouldGeneratePrintOrder
    );

    defaultParentNameOrderPreference.forEach(order => {
      const isInitial = _.includes(order, "_INITIAL");
      const cleanOrder = getCleanNameOption(order, true);
      const propertyName = NAME_MAPPING[cleanOrder];
      const propertyValue = _.get(familyMember, propertyName, "");

      if (propertyValue) {
        if (fullName) {
          fullName += " ";
        }
        if (isInitial) {
          const cleanOrderWithInitial = getCleanNameOption(order);
          fullName += _.replace(
            order,
            cleanOrderWithInitial,
            propertyValue.charAt(0)
          );
        } else {
          fullName += _.replace(order, cleanOrder, propertyValue);
        }
      }
    });
    return fullName;
  }

  return `${firstName} ${lastName}`.trim();
};

export const getFamilyMemberIdentifierName = ({ familyMember }) => {
  if (ACLStore.can(ENABLE_USER_MIDDLE_NAME)) {
    return getFormattedFamilyMemberName({ familyMember });
  }

  const defaultPropertyName = NAME_MAPPING[FIRST_NAME];
  const defaultValue = _.get(familyMember, defaultPropertyName, "");

  return defaultValue;
};
